<template>
  <widgetModal
    :title="newProject.id ? 'Updated project' : 'Add New Project'"
    subtitle="You can add information directly from this form"
    btnlefttext="Save Changes"
    btncentertext="Cancel"
    btnrighttext=""
    :leftloading="save_project_loading"
    :rightloading="false"
    :centerloading="false"
    :footerhidden="false"
    footer_padding="20px 20px"
    header_padding="30px 30px"
    body_padding="0px 30px"
    width="600px"
    @onLeftClick="submitProject()"
    @onCenterClick="closeAddUpdateForm()"
  >
    <div class="widget-modal-body-scoll">
      <div class="row">
        <widgetInputWrapper title="Project Name">
          <widgetInput
            type="text"
            placeholder="E.g.  Perfomance Boosting"
            v-model="newProject.name"
          ></widgetInput>
        </widgetInputWrapper>
        <div class="h-spacer"></div>
        <widgetInputWrapper title="Time Frame">
          <widgetDateRangePicker
            :isSecondDatePickerDisables="date.from === ''"
            :firstDatePickerDisabledDates="{ to: new Date() }"
            :secondDatePickerDisabledDates="{ to: date.from || new Date() }"
            v-model="date"
          ></widgetDateRangePicker>
        </widgetInputWrapper>
      </div>
      <widgetInputWrapper title="Description">
        <html-editor v-model="newProject.description" id="project-descr" />
      </widgetInputWrapper>
      <div class="row">
        <widgetInputWrapper title="Hourly Rate">
          <widgetInput
            type="text"
            placeholder="USD"
            v-model="newProject.hourly_rate"
          ></widgetInput>
        </widgetInputWrapper>
        <div class="h-spacer"></div>
        <widgetInputWrapper title="Location">
          <map-helper v-model="newProject.address"></map-helper>
        </widgetInputWrapper>
      </div>
      <widgetInputWrapper title="Project Members">
        <widgetInvite v-model="invites"></widgetInvite>
      </widgetInputWrapper>
      <widgetInputWrapper title="Skills">
        <skillsInput
          v-model="newProject.skills"
          :data="newProject.skills_data"
        />
      </widgetInputWrapper>
    </div>
  </widgetModal>
</template>
<script>
import skillsInput from "@/components/Partials/skillsInput.vue";
import { eventBus } from "@/main";

export default {
  name: "projects",
  components: {
    skillsInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    account_id: {
      type: Number,
      default: 0,
    },
    account_name: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      save_project_loading: false,
      invitation: {
        target: "",
        email: "",
        note: "",
        type: "",
        id: 0,
      },
      newProject: {
        id: null,
        account_id: null,
        skills: {},
        name: "",
        company: "",
        from: "",
        to: "",
        country: 0,
        city: 0,
        address: "",
        description: "",
        hourly_rate: "",
        member: "",
        langs: [],
        langNames: [],
        members: [],
        people: [],
        invites: [],
        show: false,
        roles: [],
        role: "",
      },
      date: {
        from: null,
        to: null,
      },
      invites: [],
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      console.log(vm.value);
      vm.setProjectContentOnForm(vm.value);
    } else {
      vm.addUpdateForm();
    }
  },
  computed: {},
  methods: {
    submitProject() {
      let vm = this;
      vm.newProject.members = vm.invites
        .filter((item) => item.type == "host")
        .map((item) => {
          return item.id;
        });
      vm.newProject.invites = vm.invites
        .filter((item) => item.type == "guest")
        .map((item) => {
          return item;
        });
      Object.keys(vm.newProject.skills).forEach(function (key) {
        vm.newProject[key] = vm.newProject.skills[key];
      });
      vm.newProject.from = vm.moment(vm.date.from).format("YYYY-MM-DD");
      vm.newProject.to = vm.moment(vm.date.to).format("YYYY-MM-DD");

      if (!vm.newProject.id) {
        vm.save_project_loading = true;
        // Add new project
        vm.$store
          .dispatch("SAVE_PROJECT", vm.newProject)
          .then((responce) => {
            vm.save_project_loading = false;
            vm.$emit("saved");
          })
          .catch((error) => {
            vm.save_project_loading = false;
            console.log({ error });
          });
      } else {
        vm.save_project_loading = true;
        // Update project
        vm.$store
          .dispatch("EDIT_PROJECT_ITEM", vm.newProject)
          .then((responce) => {
            vm.save_project_loading = false;
            vm.$emit("saved");
          })
          .catch((error) => {
            vm.save_project_loading = false;
            console.log({ error });
          });
      }
    },
    setProjectContentOnForm(item) {
      let vm = this;
      // fields
      vm.newProject.id = item.id;
      vm.newProject.account_id = vm.account_id;
      vm.newProject.skills = item.skills;
      vm.newProject.skills_data = item.skills_data;
      vm.newProject.name = item.name;
      vm.newProject.company = vm.account_name;

      vm.date.from = item.from ? vm.moment(item.from).toDate() : "";
      vm.date.to = item.to ? vm.moment(item.to).toDate() : "";

      vm.newProject.address = item.address;
      vm.newProject.description = item.description;
      vm.newProject.hourly_rate = item.hourly_rate;
      //vm.newProject.member = item.members;
      vm.newProject.langs = [];
      vm.newProject.langNames = [];
      vm.newProject.members = [];
      vm.newProject.people = [];
      vm.newProject.invites = [];
      vm.newProject.roles = [];
      vm.newProject.role = item.role;
      vm.add_update_form = true;
      vm.is_items_list_open = false;
    },
    addUpdateForm() {
      let vm = this;
      vm.newProject = {
        id: null,
        account_id: vm.account_id,
        skills: {},
        name: "",
        company: vm.account_name,
        from: "",
        to: "",
        country: 0,
        city: 0,
        address: "",
        description: "",
        hourly_rate: "",
        member: "",
        langs: [],
        langNames: [],
        members: [],
        people: [],
        invites: [],
        show: false,
        roles: [],
        role: "",
      };
      vm.date.from = vm.moment().toDate();
      vm.date.to = vm.moment().toDate();
    },
    closeAddUpdateForm() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
</style>